import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { LoaderIcon } from '@/components/ui/loader-icon';
import MultipleSelector from '@/components/ui/multi-select';
import { ComponentProps } from 'react';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

interface FormMultiSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  form: UseFormReturn<TFieldValues>;
  name: TName;
  label: string;
  className?: string;
  multipleSelectorProps?: ComponentProps<typeof MultipleSelector>;
  required?: boolean;
}

export function FormMultiSelect<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  form,
  name,
  label,
  className = '',
  multipleSelectorProps = {},
  required = false,
}: FormMultiSelectProps<TFieldValues, TName>) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel className="font-bold">
            {label}
            {required && '*'}
          </FormLabel>
          <FormControl>
            <MultipleSelector
              loadingIndicator={<LoaderIcon />}
              emptyIndicator={
                <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">no results found.</p>
              }
              triggerSearchOnFocus
              hideClearSingleItemButton={multipleSelectorProps.maxSelected === 1}
              {...multipleSelectorProps}
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
